import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את הקצה",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב כשהמחשבה רצה לקצה.",
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "היום אני שם/ה לב כשהמחשבה רצה לקצה.",
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזו מחשבה קופצת ישר לקצה?",
      "מה הדבר הכי גרוע שאני מדמיין/ת?",
      "מה אני מרגיש/ה בגוף כשזה עולה?"
    ],
      [
      "איזו מחשבה קופצת ישר לקצה?",
      "מה הדבר הכי גרוע שאני מדמיין/ת?",
      "מה אני מרגיש/ה בגוף כשזה עולה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מחשבה קיצונית היא מחשבה, לא מציאות."
    ],
      [
      "מחשבה קיצונית היא מחשבה, לא מציאות."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת ומשפט בלב - אני כאן.",
      "נשימה אחת ומשפט בלב - אני כאן."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "הטריגר הראשון",
    opening: localizedGenderNode(
      [
      "היום אני מזהה מה מפעיל את הקטסטרופה.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ],
      [
      "היום אני מזהה מה מפעיל את הקטסטרופה.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי זה עולה הכי מהר?",
      "איזה טריגר חוזר שוב ושוב?",
      "מה אני מנסה להגן עליו?"
    ],
      [
      "מתי זה עולה הכי מהר?",
      "איזה טריגר חוזר שוב ושוב?",
      "מה אני מנסה להגן עליו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לפעמים המוח מחמיר כדי להרגיש בשליטה."
    ],
      [
      "לפעמים המוח מחמיר כדי להרגיש בשליטה."
    ]
    ),
    action: localizedGenderNode(
      "אני נותן/ת שם לטריגר אחד.",
      "אני נותן/ת שם לטריגר אחד."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "עובדה מול סיפור",
    opening: localizedGenderNode(
      [
      "היום אני מפריד/ה בין עובדה לדמיון.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ],
      [
      "היום אני מפריד/ה בין עובדה לדמיון.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה העובדה היחידה שיש לי עכשיו?",
      "איזה סיפור מתלבש עליה?",
      "מה עוד לא ידוע לי?"
    ],
      [
      "מה העובדה היחידה שיש לי עכשיו?",
      "איזה סיפור מתלבש עליה?",
      "מה עוד לא ידוע לי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "חוסר ודאות מרגיש מסוכן, אבל הוא לא בהכרח סכנה."
    ],
      [
      "חוסר ודאות מרגיש מסוכן, אבל הוא לא בהכרח סכנה."
    ]
    ),
    action: localizedGenderNode(
      "משפט בלב - זה לא ודאי, ואני כאן.",
      "משפט בלב - זה לא ודאי, ואני כאן."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "להאט את הסרט",
    opening: localizedGenderNode(
      [
      "היום אני מאט/ה את הסרט.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ],
      [
      "היום אני מאט/ה את הסרט.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "באיזה שלב הסרט כבר נהיה קיצוני?",
      "מה הדימוי שחוזר על עצמו?",
      "מה אני בוחר/ת/ה ברגע הזה?"
    ],
      [
      "באיזה שלב הסרט כבר נהיה קיצוני?",
      "מה הדימוי שחוזר על עצמו?",
      "מה אני בוחר/ת/ה ברגע הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "כשאני מאט/ה, יש לי מרווח לנשימה."
    ],
      [
      "כשאני מאט/ה, יש לי מרווח לנשימה."
    ]
    ),
    action: localizedGenderNode(
      "אני עוצר/ת לחמש שניות לפני שאני ממשיך/ה לחשוב.",
      "אני עוצר/ת לחמש שניות לפני שאני ממשיך/ה לחשוב."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "דפוס חוזר",
    opening: localizedGenderNode(
      [
      "היום אני מזהה דפוס קבוע.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ],
      [
      "היום אני מזהה דפוס קבוע.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה נושא חוזר הכי הרבה?",
      "איזה זמן ביום זה עולה?",
      "מה אני עושה מיד אחר כך?"
    ],
      [
      "איזה נושא חוזר הכי הרבה?",
      "איזה זמן ביום זה עולה?",
      "מה אני עושה מיד אחר כך?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "דפוס מוכר עוזר לי לראות שזה חוזר, לא חדש."
    ],
      [
      "דפוס מוכר עוזר לי לראות שזה חוזר, לא חדש."
    ]
    ),
    action: localizedGenderNode(
      "אני מסמן/ת לעצמי - זה הדפוס שלי.",
      "אני מסמן/ת לעצמי - זה הדפוס שלי."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "סימן הגוף",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לסימן הגוף הראשון.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ],
      [
      "היום אני שם/ה לב לסימן הגוף הראשון.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה בגוף זה מתחיל?",
      "מה משתנה בנשימה?",
      "מה אני רוצה לעשות כשזה מגיע?"
    ],
      [
      "איפה בגוף זה מתחיל?",
      "מה משתנה בנשימה?",
      "מה אני רוצה לעשות כשזה מגיע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הגוף מאותת מוקדם יותר מהמחשבה."
    ],
      [
      "הגוף מאותת מוקדם יותר מהמחשבה."
    ]
    ),
    action: localizedGenderNode(
      "יד אחת על החזה, נשימה אחת.",
      "יד אחת על החזה, נשימה אחת."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "גבול פנימי",
    opening: localizedGenderNode(
      [
      "היום אני יוצר/ת גבול פנימי למחשבה.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ],
      [
      "היום אני יוצר/ת גבול פנימי למחשבה.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי המחשבה כבר חוצה גבול?",
      "איזה משפט פנימי מחמיר אותה?",
      "מה אני רוצה להגיד לעצמי במקום?"
    ],
      [
      "מתי המחשבה כבר חוצה גבול?",
      "איזה משפט פנימי מחמיר אותה?",
      "מה אני רוצה להגיד לעצמי במקום?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גבול פנימי לא מעלים מחשבה, הוא מרכך אותה."
    ],
      [
      "גבול פנימי לא מעלים מחשבה, הוא מרכך אותה."
    ]
    ),
    action: localizedGenderNode(
      "אני אומר/ת לעצמי משפט גבול אחד.",
      "אני אומר/ת לעצמי משפט גבול אחד."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "בדיקה עדינה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת בדיקה עדינה.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ],
      [
      "היום אני בוחר/ת בדיקה עדינה.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני יודע/ת בוודאות כרגע?",
      "מה אני מניח/ה בלי בדיקה?",
      "מה אפשר להניח בצד לעכשיו?"
    ],
      [
      "מה אני יודע/ת בוודאות כרגע?",
      "מה אני מניח/ה בלי בדיקה?",
      "מה אפשר להניח בצד לעכשיו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "דיוק קטן מוריד דרמה גדולה."
    ],
      [
      "דיוק קטן מוריד דרמה גדולה."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת שורה אחת של עובדה.",
      "אני כותב/ת שורה אחת של עובדה."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "יחס רך למחשבה",
    opening: localizedGenderNode(
      [
      "היום אני פוגש/ת את המוח בלי מלחמה.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ],
      [
      "היום אני פוגש/ת את המוח בלי מלחמה.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה המוח מנסה לעשות בשבילי?",
      "מה הוא מפחד שיקרה?",
      "איך זה מרגיש כשאני רך/ה איתו?"
    ],
      [
      "מה המוח מנסה לעשות בשבילי?",
      "מה הוא מפחד שיקרה?",
      "איך זה מרגיש כשאני רך/ה איתו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גם מחשבה קיצונית היא ניסיון להגן."
    ],
      [
      "גם מחשבה קיצונית היא ניסיון להגן."
    ]
    ),
    action: localizedGenderNode(
      "משפט בלב - תודה שהזהרת, אני נושם/ת.",
      "משפט בלב - תודה שהזהרת, אני נושם/ת."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "צורך מתחת לפחד",
    opening: localizedGenderNode(
      [
      "היום אני מנסח/ת צורך מתחת לפחד.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ],
      [
      "היום אני מנסח/ת צורך מתחת לפחד.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה צורך יש מתחת למחשבה?",
      "מה היה מרגיע אותי במעט?",
      "מה אני מבקש/ת מעצמי?"
    ],
      [
      "איזה צורך יש מתחת למחשבה?",
      "מה היה מרגיע אותי במעט?",
      "מה אני מבקש/ת מעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "כשאני מזהה צורך, יש לי כיוון."
    ],
      [
      "כשאני מזהה צורך, יש לי כיוון."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת צורך אחד במשפט.",
      "אני כותב/ת צורך אחד במשפט."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "בקשה קטנה מעצמי",
    opening: localizedGenderNode(
      [
      "היום אני מבקש/ת בקשה קטנה מעצמי.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ],
      [
      "היום אני מבקש/ת בקשה קטנה מעצמי.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזו בקשה קטנה אפשרית לי?",
      "מה יהיה סימן קטן שזה עובד?",
      "מה יכול להפריע לי?"
    ],
      [
      "איזו בקשה קטנה אפשרית לי?",
      "מה יהיה סימן קטן שזה עובד?",
      "מה יכול להפריע לי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה קטנה היא לא כיוון, היא התחלה."
    ],
      [
      "בקשה קטנה היא לא כיוון, היא התחלה."
    ]
    ),
    action: localizedGenderNode(
      "אני אומר/ת את הבקשה לעצמי בשקט.",
      "אני אומר/ת את הבקשה לעצמי בשקט."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "שינוי של 5%",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת שינוי קטן בהרגל החשיבה.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ],
      [
      "היום אני בוחר/ת שינוי קטן בהרגל החשיבה.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הרגל אחד שאני יכול/ה לשנות בחמישה אחוזים?",
      "מתי הכי מתאים לי לנסות?",
      "מה יהיה צעד ראשון?"
    ],
      [
      "מה הרגל אחד שאני יכול/ה לשנות בחמישה אחוזים?",
      "מתי הכי מתאים לי לנסות?",
      "מה יהיה צעד ראשון?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "שינוי קטן יוצר מסלול חדש."
    ],
      [
      "שינוי קטן יוצר מסלול חדש."
    ]
    ),
    action: localizedGenderNode(
      "אני מסמן/ת צעד ראשון אחד.",
      "אני מסמן/ת צעד ראשון אחד."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "עוגן קטן",
    opening: localizedGenderNode(
      [
      "היום אני בונה עוגן קטן ליום קשה.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ],
      [
      "היום אני בונה עוגן קטן ליום קשה.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה משפט מחזיק אותי?",
      "איזה מקום בגוף מרגיש בטוח?",
      "מה עוזר לי לחזור לרגע הזה?"
    ],
      [
      "איזה משפט מחזיק אותי?",
      "איזה מקום בגוף מרגיש בטוח?",
      "מה עוזר לי לחזור לרגע הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "עוגן קטן מזכיר לי שאני לא רוצה/ת לרוץ עם המחשבה."
    ],
      [
      "עוגן קטן מזכיר לי שאני לא רוצה/ת לרוץ עם המחשבה."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר/ת עוגן אחד ומזכיר/ה אותו.",
      "אני בוחר/ת עוגן אחד ומזכיר/ה אותו."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני סוגר/ת בעדינות.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ],
      [
      "היום אני סוגר/ת בעדינות.",
      "אני עוצר/ת.",
      "נשימה אחת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על המחשבות הקטסטרופליות שלי?",
      "מה הסימן המוקדם ביותר?",
      "איזה משפט מחזיר אותי לרגע לפני?"
    ],
      [
      "מה למדתי על המחשבות הקטסטרופליות שלי?",
      "מה הסימן המוקדם ביותר?",
      "איזה משפט מחזיר אותי לרגע לפני?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני יכול/ה להיות עם מחשבה ולבחור תגובה."
    ],
      [
      "אני יכול/ה להיות עם מחשבה ולבחור תגובה."
    ]
    ),
    action: localizedGenderNode(
      "משפט סיום - אני עוצר/ת, נושם/ת, ובוחר/ת רגע לפני תגובה.",
      "משפט סיום - אני עוצר/ת, נושם/ת, ובוחר/ת רגע לפני תגובה."
    ),
  },
].map(buildNormalizedDay);

export const catastrophicThoughtsBlueprintHe = buildNormalizedPilotBlueprint({
  id: "catastrophic_thoughts_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "catastrophic_thoughts",
  category: "general",
  journeyName: {
    he: "מחשבות קטסטרופליות",
    en: "Catastrophic Thoughts",
    es: "Pensamientos catastroficos",
  },
  days,
});

export default catastrophicThoughtsBlueprintHe;
